const ANALYTICS_EVENTS = {
  MENU_CURATOR_UPDATE_DISH: {
    MENU_CURATOR_START_UPDATE_DISH: 'menu_curator_start_update_dish',
    MENU_CURATOR_END_UPDATE_DISH: 'menu_curator_end_update_dish',
    MENU_CURATOR_START_AI_UPDATE_DISH: 'menu_curator_start_ai_update_dish',
    MENU_CURATOR_END_AI_UPDATE_DISH: 'menu_curator_end_ai_update_dish',
  },
  MENU_CURATOR_KEYBOARD_SHORTCUTS: {
    MENU_CURATOR_USE_KEYBOARD_SHORTCUTS: 'menu_curator_use_keyboard_shortcuts',
  },
  MENU_CURATOR_LOAD_MENU_TASKS: {
    MENU_CURATOR_START_LOAD_MENU_TASKS: 'menu_curator_start_load_menu_tasks',
    MENU_CURATOR_END_LOAD_MENU_TASKS: 'menu_curator_end_load_menu_tasks',
  },
  MENU_CURATOR_LOAD_MENU_TASK: {
    MENU_CURATOR_START_LOAD_MENU_TASK: 'menu_curator_start_load_menu_task',
    MENU_CURATOR_END_LOAD_MENU_TASK: 'menu_curator_end_load_menu_task',
  },
  MENU_CURATOR_LOAD_DISHES: {
    MENU_CURATOR_START_LOAD_DISHES: 'menu_curator_start_load_dishes',
    MENU_CURATOR_END_LOAD_DISHES: 'menu_curator_end_load_dishes',
  },
  MENU_CURATOR_LOAD_UNKNOWN_WORDS: {
    MENU_CURATOR_START_LOAD_UNKNOWN_WORDS:
      'menu_curator_start_load_unknown_words',
    MENU_CURATOR_END_LOAD_UNKNOWN_WORDS: 'menu_curator_end_load_unknown_words',
  },
  MENU_CURATOR_UPDATE_UNKNOWN_WORDS: {
    MENU_CURATOR_START_UPDATE_UNKNOWN_WORDS:
      'menu_curator_start_update_unknown_words',
    MENU_CURATOR_END_UPDATE_UNKNOWN_WORDS:
      'menu_curator_end_update_unknown_words',
  },
  MENU_CURATOR_UPDATE_MENU_TASK: {
    MENU_CURATOR_START_UPDATE_MENU_TASK: 'menu_curator_start_update_menu_task',
    MENU_CURATOR_END_UPDATE_MENU_TASK: 'menu_curator_end_update_menu_task',
    MENU_CURATOR_RETRY_CURATION: 'menu_curator_retry_curation',
    MENU_CURATOR_RETRY_LABELS_INGREDIENTS:
      'menu_curator_retry_labels_ingredients',
    MENU_CURATOR_RETRY_MENU_TITLE_LABELS_INGREDIENTS:
      'menu_curator_retry_menu_title_labels_ingredients',
  },
}

export default ANALYTICS_EVENTS
